import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import UnsubscribePage from './pages/UnsubscribePage';
import NewsletterOptInPage from './pages/NewsletterOptInPage';
import SimplieCalculatorPage from './pages/SimplieCalculatorPage';
import EventLandingPage from './pages/EventLandingPage';
import PublicEventLandingPage from './pages/public/PublicEventLandingPage';
import SeminarDinnerRegistrationPage from './pages/public/SeminarDinnerRegistrationPage';
import CutierHubPage from './pages/CutierHubPage';
import NeukundenIntakePage from './pages/NeukundenIntakePage';
import BwaUploadPage from './pages/BwaUploadPage';
import AutoUpdateModal from './components/AutoUpdateModal';
import { isCutierHost } from './utils/cutierHost';

/** /event und /event/:slug — bewusst NICHT /events (Auth-App). */
export const isPublicOnlineEventPath = (pathname: string): boolean =>
    pathname === '/event' || pathname.startsWith('/event/');

/** /seminar-dinner und /seminar-dinner/:seminarId — Abendessen ohne App-Login. */
export const isSeminarDinnerPath = (pathname: string): boolean =>
    pathname === '/seminar-dinner' || pathname.startsWith('/seminar-dinner/');

/** Einzige Quelle für öffentliche Pfade — App.tsx kennt diese Routen nicht. */
export const isPublicAppPath = (pathname: string = window.location.pathname): boolean => {
    if (isCutierHost()) return true;
    return (
        pathname.includes('/unsubscribe') ||
        pathname.includes('/einladung') ||
        pathname.includes('/simplie-kalkulator') ||
        isSeminarDinnerPath(pathname) ||
        pathname.includes('/seminar') ||
        pathname.includes('/cutier') ||
        pathname.includes('/neukunden') ||
        pathname.includes('/bwa-upload') ||
        isPublicOnlineEventPath(pathname)
    );
};

/**
 * Öffentliches App-Shell: kein Auth, kein Boot, kein Admin/CRM.
 * Wird nur von index.tsx gemountet, wenn isPublicAppPath() true ist.
 */
const PublicAppShell: React.FC = () => {
    const cutierOnly = isCutierHost();
    return (
        <BrowserRouter>
            <AutoUpdateModal />
            <Routes>
                {cutierOnly ? (
                    <>
                        <Route path="/cutier" element={<CutierHubPage />} />
                        <Route path="/cutier/*" element={<CutierHubPage />} />
                        <Route path="*" element={<CutierHubPage />} />
                    </>
                ) : (
                    <>
                        <Route path="/unsubscribe" element={<UnsubscribePage />} />
                        <Route path="/einladung" element={<NewsletterOptInPage />} />
                        <Route path="/simplie-kalkulator" element={<SimplieCalculatorPage />} />
                        <Route path="/seminar-dinner/:seminarId" element={<SeminarDinnerRegistrationPage />} />
                        <Route path="/seminar-dinner" element={<SeminarDinnerRegistrationPage />} />
                        <Route path="/seminar/:eventId" element={<EventLandingPage />} />
                        <Route path="/seminar" element={<EventLandingPage />} />
                        <Route path="/event/:slug" element={<PublicEventLandingPage />} />
                        <Route path="/event" element={<PublicEventLandingPage />} />
                        <Route path="/neukunden" element={<NeukundenIntakePage />} />
                        <Route path="/bwa-upload" element={<BwaUploadPage />} />
                        <Route path="/cutier" element={<CutierHubPage />} />
                        <Route path="/cutier/*" element={<CutierHubPage />} />
                        <Route
                            path="*"
                            element={
                                window.location.pathname.includes('/unsubscribe') ? (
                                    <UnsubscribePage />
                                ) : window.location.pathname.includes('/simplie-kalkulator') ? (
                                    <SimplieCalculatorPage />
                                ) : isSeminarDinnerPath(window.location.pathname) ? (
                                    <SeminarDinnerRegistrationPage />
                                ) : window.location.pathname.includes('/seminar') ? (
                                    <EventLandingPage />
                                ) : isPublicOnlineEventPath(window.location.pathname) ? (
                                    <PublicEventLandingPage />
                                ) : window.location.pathname.includes('/cutier') ? (
                                    <CutierHubPage />
                                ) : window.location.pathname.includes('/neukunden') ? (
                                    <NeukundenIntakePage />
                                ) : window.location.pathname.includes('/bwa-upload') ? (
                                    <BwaUploadPage />
                                ) : (
                                    <NewsletterOptInPage />
                                )
                            }
                        />
                    </>
                )}
            </Routes>
        </BrowserRouter>
    );
};

export default PublicAppShell;
